
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { GroupeFormationModel } from 'src/models/groupe-formation/groupe-formation-model';
import { UtilisateurFormationModel } from 'src/models/groupe-formation/utilisateur-formation-model';

@Component({
    selector: 'app-show-participant-dialog',
    templateUrl: './show-participant-dialog.component.html',
    styleUrls: ['./show-participant-dialog.component.scss'],
    imports: [
    FormsModule,
    TranslateModule
]
})
export class ShowParticipantDialogComponent implements OnInit {
  formation!: GroupeFormationModel;
  participants: UtilisateurFormationModel[] = [];
  constructor(
    public dialogRef: MatDialogRef<ShowParticipantDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public data: GroupeFormationModel
  ) {
    this.formation = data;
  }

  ngOnInit() {
    if(this.formation.dateCompletee != null){
      this.participants = this.formation.utilisateurs.filter(user => user.utilisateurId !== this.formation.priseEnChargeParUtilisateurId).sort((a, b) => a.prenom.localeCompare(b.prenom));
    } else {
      this.participants = this.formation.utilisateurs.sort((a, b) => a.prenom.localeCompare(b.prenom));
    }
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
